
<app-squat></app-squat>
<section class="main" id="main">
  <img src="/12.jpg" alt="Image de fond" class="background-image">
  <div class="content">
    <h1>AI: A Revolution, <span class="colorthree">A Fresh Start</span></h1>
    <div class="animation">
      <p>Shaping the Careers of Tomorrow Unlocking the Keys to Success</p>
    </div>
    <a href="#about" class="btn">Discover</a>
  </div>
</section>
<section class="about" id="about">
  <div class="container">
    <div class="title reveal">
      <h2 class="section-title colorb">Unleash Your Potential with Cognitiex: Innovation for Meaningful Growth</h2>
    </div>
    <img src="/4.png" alt="Image de fond" class="background-image">
    <div class="content">
      <div class="col-left reveal">

        <a href="#services" class="btn">Explore our services</a>
      </div>
      <div class="col-right reveal">
        <h2 class="content-title">Cognitiex: Where Cutting-Edge Technology Meets Human Connection</h2>
        <p class="para-text">
          Imagine turning digital challenges into springboards for success. With Cognitiex, this vision becomes reality. Our unique approach combines the sharp precision of technology with the warmth and depth of human expertise
        </p>
        <p class="para-text">
          Our mission is simple yet profound: to amplify your potential by blending the brilliance of innovation with the insights of behavioral science.
        </p>
        <p class="para-text">
          Partner with Cognitiex to unlock strategic, disruptive solutions tailored to your ambitions. Your growth is our purpose.
        </p>
      </div>
    </div>
  </div>
</section>
<app-mirror></app-mirror>
<app-mecontact></app-mecontact>
<h1>
  Pose Coach est disponible. Mais ce n’est qu’un début.
</h1>
